module.exports = __webpack_public_path__ + "img/company-3.35307101.jpg";